// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2p_mX","inputWrap":"CustomTip_inputWrap__3SIgv"};